import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { Form, Radio, DatePicker, Button, Select, Input } from "antd/lib";
import IncomeData from "./IncomeData";
import { PospNavBar } from "../Navbar/PospNav";
import Male from "../../images/boy-face.png";
import Female from "../../images/female-face.png";
import SmokeImg from "../../assets/cigarette_smoke.png";
import NonSmokeImg from "../../assets/no_smoke.png";
import { CalendarOutlined } from "@ant-design/icons";
import axiosInPosp from "../../Redux/axios/AxiosInPosp";
import { OfflineLifeData } from "../../Redux/actions/NumLife";

const OfflineLife = () => {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const CusDeatail = useSelector((state) => state?.lifedetail?.cusInfo);
  const [dob, setDob] = useState("");
  const [Age, setAge] = useState(
    CusDeatail?.Age ? CusDeatail?.Age + "Years" : ""
  );
  const [AgeInNum, setAgeInNum] = useState(
    CusDeatail?.Age ? CusDeatail?.Age : ""
  );
  const [gvalue, setValue] = useState(CusDeatail ? CusDeatail?.gender : "M");
  const [Smokevalue, setSmokeValue] = useState(
    CusDeatail ? CusDeatail?.IsSmoker : "N"
  );
  const [loading, setLoading] = useState(false);

  const calculateAge = (date) => {
    console.log(date);
    const dateString = moment(date).format("YYYY-MM-DD");
    console.log(dateString);

    setDob(dateString);
    const dobObject = new Date(date);
    console.log(dobObject);
    const ageDifMs = Date.now() - dobObject.getTime();
    console.log(ageDifMs);

    const ageDate = new Date(ageDifMs);
    console.log(ageDate);

    const ageInYears = Math.abs(ageDate.getUTCFullYear() - 1970).toString();
    console.log(ageInYears);
    if (ageInYears === "53") {
      setAge("");
      setAgeInNum("");
    } else {
      setAge(ageInYears + " " + "years");
      setAgeInNum(ageInYears);
    }
    console.log(Age);
  };

  const disabledDate = (current) => {
    const today = moment();
    const minDate = today.subtract(18, "years");

    return current.isAfter(minDate, "day");
  };
  const getDefaultPickerValue = () => {
    const today = moment();
    const minDate = today.subtract(18, "years");
    return minDate;
  };

  const onChange = (e) => {
    // setRadioCheck(e.target.checked)
    console.log("radio checked", e.target.value);
    setValue(e.target.value);
  };
  const onChainSmoke = (e) => {
    // setRadioCheck(e.target.checked)
    console.log("radio checked", e.target.value);
    setSmokeValue(e.target.value);
  };
  const validatePolicyTerm = (_, value) => {
    const age = parseInt(CusDeatail?.Age);
    if (age >= 56) {
      return Promise.reject(
        new Error(`Plan Premium not defined for this Plan, Age :${age}.`)
      );
    }
    return Promise.resolve();
  };
  const OnFinish = (values) => {
    console.log("values", values);
    const post = {
      product_type: "LIFE",
      gender: "Male",
      smoker: "N",
      customer_dob: "2004-06-08",
      occupation: "Salaried",
      education: "Post Graduate",
      income: "200000",
      policyTerm: "10",
      firstName: "branesh",
      phonenumber: "7598473037",
      email: "branesh@posp.com",
    };
    console.log("posttt", post);
    axiosInPosp
      .post("v1/posp/quick_quotes", post)
      .then((res) => {
        console.log(res);
      })
      .catch((err) => {
        console.log(err);
      });
    // dispatch(OfflineLifeData(values))
  };
  // console.log(current)
  return (
    <>
      <PospNavBar />
      <section
        className="bg-light py-4"
        style={{ minHeight: "calc(100vh - 50px)" }}
      >
        <div className="container">
          <div className="row align-items-start justify-content-between">
            <div className="col-xl-12 col-lg-12 px-3 py-3 col-md-12  bike-info-quotebef">
              <div
                className="h6 text-blue py-3 text-center mb-0"
                style={{ fontSize: "25px", fontWeight: "700" }}
              >
                LIFE DETAILS
              </div>
              <Form
                layout="vertical"
                form={form}
                // style={{ width: "95%" }}
                requiredMark={false}
                onFinish={OnFinish}
              >
                <div className="row justify-content-center align-items-center mt-3">
                  <div className="col-xl-5 col-lg-5 col-md-4 col-sm-12">
                    <Form.Item
                      name="gender"
                      rules={[
                        {
                          required: true,
                          message: "please select",
                        },
                      ]}
                      initialValue={gvalue}
                    >
                      <Radio.Group
                        className="life-gender"
                        onChange={onChange}
                        value={gvalue}
                      >
                        <Radio.Button
                          value="M"
                          className={
                            gvalue === "M"
                              ? `active-button-life`
                              : "life-gender-rb"
                          }
                        >
                          <span>
                            <img
                              src={Male}
                              className={` ${
                                gvalue === "M"
                                  ? "remove-filter-life"
                                  : "life-gender-img"
                              }`}
                            />
                            Male
                          </span>
                        </Radio.Button>
                        <Radio.Button
                          value="F"
                          className={
                            gvalue === "F"
                              ? `active-button-life`
                              : "life-gender-rb"
                          }
                        >
                          <span>
                            <img
                              src={Female}
                              className={` ${
                                gvalue === "F"
                                  ? "remove-filter-life"
                                  : "life-gender-img"
                              }`}
                            />
                            Female
                          </span>
                        </Radio.Button>
                      </Radio.Group>
                    </Form.Item>
                  </div>

                  <div className="col-xl-5 col-lg-5 col-md-4 col-sm-12">
                    <Form.Item
                      name="smoker"
                      rules={[
                        {
                          required: true,
                          message: "please select",
                        },
                      ]}
                      initialValue={Smokevalue}
                    >
                      <Radio.Group
                        className="life-gender"
                        onChange={onChainSmoke}
                        value={Smokevalue}
                      >
                        <Radio.Button
                          value="Y"
                          className={
                            Smokevalue === "Y"
                              ? `active-button-life`
                              : "life-gender-rb"
                          }
                        >
                          <span>
                            <img
                              src={SmokeImg}
                              className={` ${
                                Smokevalue === "Y"
                                  ? "remove-filter"
                                  : "health-gender-img"
                              }`}
                            />
                            Smoker
                          </span>
                        </Radio.Button>
                        <Radio.Button
                          value="N"
                          className={
                            Smokevalue === "N"
                              ? `active-button-life`
                              : "life-gender-rb"
                          }
                        >
                          <span>
                            <img
                              src={NonSmokeImg}
                              className={` ${
                                Smokevalue === "N"
                                  ? "remove-filter"
                                  : "health-gender-img"
                              }`}
                            />
                            Non Smoker
                          </span>
                        </Radio.Button>
                      </Radio.Group>
                    </Form.Item>
                  </div>
                </div>
                <div className="row align-items-center">
                  <div className="col-xl-4 col-lg-4 col-md-3 col-sm-12">
                    <Form.Item
                      // {...formItemLayout}
                      label="Date of Birth"
                      name="dateofbirth"
                      rules={[
                        {
                          required: true,
                          message: "please input DOB",
                        },
                      ]}
                      initialValue={
                        CusDeatail?.dateofbirth
                          ? moment(CusDeatail?.dateofbirth)
                          : null
                      }
                    >
                      <DatePicker
                        disabledDate={disabledDate}
                        defaultPickerValue={getDefaultPickerValue()}
                        style={{ width: "100%", padding: "10px" }}
                        suffixIcon={
                          Age ? (
                            <div
                              style={{ display: "flex", alignItems: "center" }}
                            >
                              <span
                                style={{
                                  marginRight: "4px",
                                  color: "#0000ff94",
                                }}
                              >
                                {Age}
                              </span>
                              <CalendarOutlined />
                            </div>
                          ) : (
                            <CalendarOutlined />
                          )
                        }
                        format="YYYY-MM-DD"
                        placeholder="YYYY-MM-DD"
                        onChange={(date) => calculateAge(date)}
                      />
                    </Form.Item>
                  </div>
                  <div className="col-xl-4 col-lg-4 col-md-3 col-sm-12">
                    <Form.Item
                      name="occupation"
                      label="Occupation"
                      rules={[
                        {
                          required: true,
                          message: "please select Occupation",
                        },
                      ]}
                      initialValue={CusDeatail?.Occupation}
                    >
                      <Select
                        // onChange={handleChange}
                        style={{ textAlign: "left" }}
                        placeholder="Occupation"
                        options={[
                          {
                            value: "Salaried",
                            label: "Salaried",
                          },
                          {
                            value: "Self Employed",
                            label: "Self Employed",
                          },
                        ]}
                      />
                    </Form.Item>
                  </div>
                  <div className="col-xl-4 col-lg-4 col-md-3 col-sm-12">
                    <Form.Item
                      name="education"
                      label="Education"
                      rules={[
                        {
                          required: true,
                          message: "please select Education",
                        },
                      ]}
                      initialValue={CusDeatail?.Education}
                    >
                      <Select
                        style={{ textAlign: "left" }}
                        placeholder="Education"
                        options={[
                          {
                            value: "Post Graduate",
                            label: "Post Graduate",
                          },
                          {
                            value: "Graduate",
                            label: "Graduate",
                          },
                          {
                            value: "12th Pass",
                            label: "12th Pass",
                          },
                          {
                            value: "10th Pass",
                            label: "10th Pass",
                          },
                        ]}
                      />
                    </Form.Item>
                  </div>
                  <div className="col-xl-4 col-lg-4 col-md-3 col-sm-12">
                    <Form.Item
                      name="income"
                      label="Annual Income"
                      rules={[
                        {
                          required: true,
                          message: "please select Income",
                        },
                      ]}
                      initialValue={CusDeatail?.Income}
                    >
                      <Select
                        style={{ textAlign: "left" }}
                        placeholder="Annual Income"
                        options={IncomeData?.map((p) => ({
                          value: p?.value,
                          label: p?.label,
                        }))}
                      />
                    </Form.Item>
                  </div>
                  <div className="col-xl-4 col-lg-4 col-md-3 col-sm-12">
                    <Form.Item
                      name="policyTerm"
                      label="Policy Term"
                      rules={[
                        {
                          required: true,
                          message: "please select Income",
                        },
                        {
                          validator: validatePolicyTerm,
                        },
                      ]}
                      initialValue={CusDeatail?.PolicyTerm}
                    >
                      <Select
                        style={{ textAlign: "left" }}
                        placeholder="Policy Term"
                        options={[
                          {
                            value: "10",
                            label: "10 Years",
                          },
                          {
                            value: "12",
                            label: "12 Years",
                          },
                          {
                            value: "15",
                            label: "15 Years",
                          },
                        ]}
                      />
                    </Form.Item>
                  </div>
                  <div className="col-xl-4 col-lg-4 col-md-3 col-sm-12">
                    <Form.Item
                      label="Name"
                      name="name"
                      rules={[
                        {
                          pattern: /^[A-Za-z\s]+$/,
                          message: "Invalid Name, only letters are allowed",
                        },
                        {
                          required: true,
                          message: "please input name",
                        },
                      ]}
                      initialValue={CusDeatail?.Name}
                    >
                      <Input placeholder="Enter Name (eg. Harry)" />
                    </Form.Item>
                  </div>
                  <div className="col-xl-4 col-lg-4 col-md-3 col-sm-12">
                    <Form.Item
                      label="Mobile Number"
                      name="phonenumber"
                      rules={[
                        {
                          pattern: /^([0|+[0-9]{1,5})?([6-9][0-9]{9})$/,
                          message: "Invalid Mobile No",
                        },
                        { required: true, message: "Enter Mobile No" },
                      ]}
                      initialValue={CusDeatail?.Mobile}
                    >
                      <Input maxLength={10} placeholder="Mobile NUmber" />
                    </Form.Item>
                  </div>
                  <div className="col-xl-4 col-lg-4 col-md-3 col-sm-12">
                    <Form.Item
                      label="Email"
                      name="email"
                      rules={[
                        {
                          required: true,
                          type: "email",
                          message: "Please Input Email",
                        },
                      ]}
                      initialValue={CusDeatail?.Email}
                    >
                      <Input
                        autoComplete="off"
                        style={{ width: "100%" }}
                        placeholder="Email"
                      />
                    </Form.Item>
                  </div>
                </div>
                <div className="row justify-content-center">
                  <div className="col-xl-4 col-lg-4 col-md-3 col-sm-12">
                    <Form.Item>
                      <div className="step-btn-health">
                        <Button
                          loading={loading}
                          style={{ width: "100%" }}
                          type="primary"
                          htmlType="submit"
                        >
                          SUBMIT REQUEST
                        </Button>
                      </div>
                    </Form.Item>
                  </div>
                </div>
              </Form>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default OfflineLife;
